import { FC, memo } from 'react';

export const IconHandle: FC = memo(() => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='22'
    viewBox='0 0 23 22'
    fill='none'
  >
    <path
      d='M7.22201 4.88883C8.23453 4.88883 9.05534 4.06802 9.05534 3.0555C9.05534 2.04298 8.23453 1.22217 7.22201 1.22217C6.20948 1.22217 5.38867 2.04298 5.38867 3.0555C5.38867 4.06802 6.20948 4.88883 7.22201 4.88883Z'
      fill='#777777'
    />
    <path
      d='M15.7776 4.88883C16.7901 4.88883 17.6109 4.06802 17.6109 3.0555C17.6109 2.04298 16.7901 1.22217 15.7776 1.22217C14.765 1.22217 13.9442 2.04298 13.9442 3.0555C13.9442 4.06802 14.765 4.88883 15.7776 4.88883Z'
      fill='#777777'
    />
    <path
      d='M9.05534 10.9999C9.05534 12.0125 8.23453 12.8333 7.22201 12.8333C6.20948 12.8333 5.38867 12.0125 5.38867 10.9999C5.38867 9.98742 6.20948 9.16661 7.22201 9.16661C8.23453 9.16661 9.05534 9.98742 9.05534 10.9999Z'
      fill='#777777'
    />
    <path
      d='M15.7776 12.8333C16.7901 12.8333 17.6109 12.0125 17.6109 10.9999C17.6109 9.98742 16.7901 9.16661 15.7776 9.16661C14.765 9.16661 13.9442 9.98742 13.9442 10.9999C13.9442 12.0125 14.765 12.8333 15.7776 12.8333Z'
      fill='#777777'
    />
    <path
      d='M9.05534 18.9444C9.05534 19.9569 8.23453 20.7777 7.22201 20.7777C6.20948 20.7777 5.38867 19.9569 5.38867 18.9444C5.38867 17.9319 6.20948 17.1111 7.22201 17.1111C8.23453 17.1111 9.05534 17.9319 9.05534 18.9444Z'
      fill='#777777'
    />
    <path
      d='M15.7776 20.7777C16.7901 20.7777 17.6109 19.9569 17.6109 18.9444C17.6109 17.9319 16.7901 17.1111 15.7776 17.1111C14.765 17.1111 13.9442 17.9319 13.9442 18.9444C13.9442 19.9569 14.765 20.7777 15.7776 20.7777Z'
      fill='#777777'
    />
  </svg>
));
IconHandle.displayName = 'IconMaximize';
